import * as Sentry from "@sentry/browser";
import { sentryConfig } from "./config.ts";

/** True iff Sentry was actually initialised. Other modules use this to skip
 *  capture/breadcrumb calls when Sentry is disabled (DSN unset). */
export const sentryEnabled: boolean = (() => {
  if (!sentryConfig.dsn) return false;
  Sentry.init({
    dsn: sentryConfig.dsn,
    environment: sentryConfig.environment,
    release: sentryConfig.release,
    tracesSampleRate: sentryConfig.tracesSampleRate,
    sendDefaultPii: false,
  });
  return true;
})();

/** Re-export so callers don't need to import @sentry/browser directly. */
export { Sentry };
